import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { CommunityRow } from '../outreachTypes';
import { useRetry } from './useRetry';

/**
 * `outreach.communities.list` (design outreach r1): the read-only list of `community` targets
 * (Reddit subreddits) that fit the artist's sound profile, biggest first. `catalogItemUuid` rides
 * the route but does not filter; it is passed so the call matches the web and native contract.
 */
export function useCommunities(accountId: number, catalogItemUuid: string | null) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.communities.list.queryOptions({ accountId, catalogItemUuid }, { retry: false })
  );
  const retry = useRetry(query.refetch);
  return {
    rows: (query.data as CommunityRow[] | undefined) ?? [],
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
